import React from "react";
const AmtToBeCollect = props => {
  return (
    <div className="amount_tobe_collected p-3">
      <div className="row">
        <div className="amount_tobe_collected_inner px-3 py-1">
          <p className="amount_label">Amount to be collected</p>
          <p className="collected_amount">
            {props.TotalAmt.amount_to_be_collected}
          </p>
          <p className="collected_payment_mode">{`${props.TotalAmt.order_type} : ${props.TotalAmt.payment_mode}`}</p>
        </div>
      </div>
      {/* {props.TotalAmt.collectable_sodexo ? (
        <div className="row">
          <div className="payment_mode_container pt-3 pl-3 pr-3">
            <div className="payment_mode_label">
              Sodexo / Eden Red able Amount
            </div>
            <p className="payment_mode_amount">
              {props.TotalAmt.collectable_sodexo}
            </p>
          </div>
        </div>
      ) : (
        ""
      )} */}
    </div>
  );
};
export default AmtToBeCollect;



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/AmtToBeCollect.js